import { useState, useEffect } from "react";
import { ListLayout } from "../../../layouts";
import { DataGrid, Dialog } from "../../../components";
import {
  notification,
  ProdutosService,
  SubgrupoProdutosService,
} from "../../../services";
import { responseErros } from "../../../utils";
import AddSubgruposProdutos from "../addSubgrupos/addSubgrupos.view";
import { PermisoesHelper } from "../../../helpers";

const ListSubgrupoProdutosView = () => {
  const subgrupoProdutosService = new SubgrupoProdutosService();
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("grupo-produtos-visualizar");
  const produtosService = new ProdutosService();
  const [loading, setLoading] = useState(false);
  const [subgrupoProdutosId, setSubgrupoProdutosId] = useState(null);
  const [produtosList, setProdutosList] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [subgruposProdutos, setSubgruposProdutos] = useState([]);
  const [rowCount, setRowCount] = useState(0);

  const colunas = [
    {
      field: "codigo",
      headerName: "Código",
      flex: 100,
    },
    {
      field: "descricao",
      headerName: "Descrição",
      flex: 700,
      filtrar: true,
    },
  ];

  useEffect(() => {
    buscaSubgruposProdutos();
    buscarProdutos();
  }, []);

  const buscaSubgruposProdutos = async (query) => {
    const filter = {
      ...query,
    };
    setLoading(true);
    const result = await subgrupoProdutosService.getAll(filter);
    if (!result.isAxiosError) {
      setRowCount(result.data.count);
      setSubgruposProdutos(result.data.rows);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const buscarProdutos = async (filtro) => {
    const filtros = {
      ...filtro,
    };
    setLoading(true);
    const res = await produtosService.getAll(filtros);
    if (!res.isAxiosError) {
      setProdutosList(res.data.rows);
    } else {
      responseErros(res);
    }
    setLoading(false);
  };

  const handleOpenDialog = (id) => {
    setSubgrupoProdutosId(id);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSubgrupoProdutosId(null);
    setOpenDialog(false);
  };

  const sendServerDatagrid = (props) => {
    buscaSubgruposProdutos(props.filtros);
  };

  const handleDeleteSubgrupoProduto = async (id) => {
    const produto = produtosList.some((item) => item.subgrupoProdutoId === id);
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir esse subgrupo de produto?`
    );
    if (retornoAlerta.isConfirmed) {
      if (produto) {
        notification.alertaGenericos(
          "Não se pode remover subgrupo inserido em outros cadastros"
        );
        return;
      }
      setLoading(true);
      const result = await subgrupoProdutosService.deletar(id);
      if (!result.isAxiosError) {
        buscaSubgruposProdutos();
        notification.deletadoSucesso();
      } else {
        setLoading(false);
        responseErros(result);
      }
    }
  };

  return (
    <ListLayout
      title="Subgrupos de Produtos"
      loading={loading}
      onClickCadastrar={handleOpenDialog}
      permissaoButton={permissoesHelper.temPermisao("grupo-produtos-cadastrar")}
    >
      <DataGrid
        rows={subgruposProdutos}
        columns={colunas}
        onClickEdit={handleOpenDialog}
        onClickDelete={handleDeleteSubgrupoProduto}
        visualizarShow={permissoesHelper.temPermisao(
          "grupo-produtos-visualizar"
        )}
        editShow={permissoesHelper.temPermisao("grupo-produtos-editar")}
        deleteShow={permissoesHelper.temPermisao("grupo-produtos-excluir")}
        paginationMode={"server"}
        sendServer={(props) => sendServerDatagrid(props)}
        rowCount={rowCount}
        hideFiltroAvancado
      />
      <Dialog
        disableEscapeKeyDown
        fullWidth
        maxWidth="md"
        open={openDialog}
        aria-labelledby="form-dialog-title"
      >
        <AddSubgruposProdutos
          id={subgrupoProdutosId}
          handleCloseDialog={handleCloseDialog}
          openDialog={openDialog}
          buscaSubgruposProdutos={buscaSubgruposProdutos}
        />
      </Dialog>
    </ListLayout>
  );
};

export default ListSubgrupoProdutosView;
